import { calculateDistance } from './geoCalculations';

function calculatePolePositions(points, poleDistance, isClosed = false) {
  if (points.length < 2 || poleDistance <= 0) return [];

  const poles = [];
  let cumulativeDistance = 0;

  // Create path including closing segment if fence is closed
  const pathPoints = isClosed && points.length > 2 ? [...points, points[0]] : points;

  // Always add first marker point as first pole
  poles.push({
    index: 1,
    position: { lat: points[0].lat, lng: points[0].lng },
    distanceFromStart: 0,
    distanceFromPrevious: 0,
    isMarker: true,
    markerIndex: 0
  });

  // Track which original point indices we've processed as markers
  let nextMarkerIndex = 1;

  for (let i = 0; i < pathPoints.length - 1; i++) {
    const startPoint = pathPoints[i];
    const endPoint = pathPoints[i + 1];
    const segmentDistance = calculateDistance(startPoint, endPoint);

    if (segmentDistance === 0) continue;

    // Check if this end point is a marker (not the closing segment endpoint)
    const isEndPointMarker = isClosed ?
      (i < points.length - 1) : // For closed fence, all original points except when closing
      (i < pathPoints.length - 1); // For open fence, all points except last iteration

    // Place poles at regular intervals along this segment
    let distanceAlongSegment = poleDistance;
    const segmentStartDistance = cumulativeDistance;

    while (distanceAlongSegment < segmentDistance) {
      const ratio = distanceAlongSegment / segmentDistance;
      const polePosition = {
        lat: startPoint.lat + (endPoint.lat - startPoint.lat) * ratio,
        lng: startPoint.lng + (endPoint.lng - startPoint.lng) * ratio
      };

      const totalDistance = segmentStartDistance + distanceAlongSegment;
      const prevPole = poles[poles.length - 1];
      const distanceFromPrevious = totalDistance - prevPole.distanceFromStart;

      poles.push({
        index: poles.length + 1,
        position: polePosition,
        distanceFromStart: totalDistance,
        distanceFromPrevious: distanceFromPrevious,
        isMarker: false,
        markerIndex: null
      });

      distanceAlongSegment += poleDistance;
    }

    cumulativeDistance += segmentDistance;

    // Always add the end point as a pole if it's a marker
    if (isEndPointMarker && nextMarkerIndex < points.length) {
      const prevPole = poles[poles.length - 1];
      const distanceFromPrevious = cumulativeDistance - prevPole.distanceFromStart;

      poles.push({
        index: poles.length + 1,
        position: { lat: endPoint.lat, lng: endPoint.lng },
        distanceFromStart: cumulativeDistance,
        distanceFromPrevious: distanceFromPrevious,
        isMarker: true,
        markerIndex: nextMarkerIndex
      });

      nextMarkerIndex++;
    }
  }

  return poles;
}

export { calculatePolePositions };